import moment from "moment/moment";

const state = {
	token: "",
	user_id: 0,
	nickname: "",
	avatar: "",
	mobile: "",
	createtime: 0,
	money: 0,
	score: 0,
	is_sale: 0, // 分销权限:0=无,1=有
	level: 0, // 
	is_vip: 0, // 是否会员
	vip_date: 0, // 会员有效期

};

const getters = {
	getLoginInfo(state) {
		return state;
	},
};

const mutations = {
	setLoginInfo(state, payload) {
		Object.keys(payload).forEach((key) => {
			if (payload.hasOwnProperty(key)) {
				state[key] = payload[key];
			}
		});
		localStorage.setItem(
			"loginInfo",
			JSON.stringify({
				version: moment(Date.now()).format("YYYY-MM-DD"),
				data: {
					...state,
				},
			})
		);
	},
	setLoginOut(state, payload) {
		state = {
			token: "",
			user_id: 0,
			nickname: "",
			avatar: "",
			mobile: "",
			createtime: 0,
			expires_in: 0,
			expiretime: 0,
			score: 0,
			is_sale: 0
		};
		localStorage.setItem(
			"loginInfo",
			JSON.stringify({
				version: moment(Date.now()).format("YYYY-MM-DD"),
				data: {
					...state,
				},
			})
		);
	},
};

export default {
	namespaced: true, // 开启namespace:true，该模块就成为命名空间模块了
	state,
	getters,
	mutations,
};